<template>
  <div class="animated fadeIn">
    <b-row
      v-for="(title, index) in titles"
      :key="index"
    >
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>{{ title }}</strong>
          </div>
          <b-row>
            <a
              v-if="photoIds.hasOwnProperty(title)"
              :href="photoIds[title][0]"
              target="_blank"
            >
              <b-card
                overlay
                :img-src="photoIds[title][1]"
                img-alt="Card Image"
                text-variant="white"
                :title="title + ' 앨범 보기(Click!)'"
              />
            </a>
            <b-col
              v-for="videoId in videoIds[title]"
              :key="videoId"
              md="6"
              class="text-center"
            >
              <div>
                <youtube
                  ref="youtube"
                  :resize="true"
                  :fit-parent="true"
                  :video-id="videoId"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Interview',
  data: function () {
    return {
      titles: ['2026 상반기', '2025 하반기', '2025 상반기', '2024 하반기', '2019 하반기', '2019 상반기', '2018 하반기', '2018 상반기'],
      photoIds: {
        '2026 상반기': ['https://photos.app.goo.gl/s8aAVdii18t5yy4f8', 'https://lh3.googleusercontent.com/pw/AP1GczOnQcNKtDA8mpZ0Z90-5curm2w3G2nIMVaBtQbBezdLwPuD7dlDkPp4riIRrM8Sm4Yx5YsNPWLLKxvpPNj9JMYWCbkfRFbmg6WVcAAG4oCvc5BhAroW3O_pAtOmnuHHcTaUR_kqn750Kv3drdjV1eo=w2118-h1412-s-no-gm?authuser=0'],
        '2025 하반기': ['https://photos.app.goo.gl/5Jd7KG94cvKnCJbC8', 'https://lh3.googleusercontent.com/pw/AP1GczMglTD1fzS0kozHtJdAgxE2h2j7Y72D0RUPP3ewg_ocS1guDZ9nwPWg5zq7wYxMudPnaIkPlMlrVixmAuYB0F9lBE7myE0FPECssPI-PcM4evIoKficz3-KhOalsyjI4hb5Hmexf4YIgveE7zIvwf8=w1910-h1271-s-no-gm?authuser=0'],
        '2025 상반기': ['https://photos.app.goo.gl/obLz1wejDSyyUDEt8', 'https://lh3.googleusercontent.com/pw/AP1GczNPOAVmFxkAaoMsjeBkCtsxIVS-ufrSugxCzBZH6h2dA-owMrw2cPz0QW3eONjq0XbccAt2z4xhhlPF31mya17Juiu3Mb1ZgIdEe0QAghd-aWk8IoyJ3ACUrhMDB-J6mH4ykmHujcDhr9GBZ9TXEJE=w1906-h1271-s-no-gm?authuser=0'],
        '2024 하반기': ['https://photos.app.goo.gl/YSDDcq46Fd39Xwwn9', 'https://lh3.googleusercontent.com/pw/AP1GczP2oiO5bcFnBOmOgdTxZSOj4Aa5jWJ8XvheSVDqWMJNL_Wq-65_09wZjY9sFq8AFJBtYVxs_dcZNRokB08XDYk54sr9h92_LJmzwsp0dpL1p2CC3MJ3wq1RnyFGo_5ZXEUOheRWNTdT-I65zqnKt-0M=w3813-h2541-s-no-gm?authuser=0']
      },
      videoIds: {
        '2019 하반기': ['WianTv0XEDI', 'SyGNPCwgvrE'],
        '2019 상반기': ['PyJGQ2bNH-M', '4_o5fEKMAY8'],
        '2018 하반기': ['DJo-VeTM_oI', 'u7iBUUM_TNw'],
        '2018 상반기': ['fiTS-jbCgEs', 'M8dEjaFY8Zw']
      }
    }
  },
  methods: {
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
